module.exports = __webpack_public_path__ + "static/images/chat/chatIconSent.png";